import { Outlet, useNavigate } from 'react-router-dom';

import { DialogHost } from '@/components/feedback/dialog';
import { useToast } from '@/components/feedback/toast';
import { routes } from '@/config/routes';
import { AUTH_POLICY, useLogout } from '@/features/auth';
import { useIdleTimeout } from '@/hooks/use-idle-timeout';
import { useAuth } from '@/providers/auth-provider';

import { PageContainer } from '../page-container';
import { TopNav } from '../top-nav';

import styles from './app-shell.module.scss';

export function AppShell() {
  const { rememberMe, clearSession } = useAuth();
  const logout = useLogout();
  const navigate = useNavigate();
  const toast = useToast();

  useIdleTimeout({
    enabled: !rememberMe,
    timeoutMs: AUTH_POLICY.idleMs,
    onIdle: async () => {
      await logout.mutateAsync().catch(() => undefined);
      clearSession();
      navigate(routes.login);
      toast.info({ title: 'Your session has expired. Please log in.' });
    },
  });

  return (
    <DialogHost>
      <div className={styles.shell}>
        <TopNav />
        <main className={styles.content}>
          <PageContainer>
            <Outlet />
          </PageContainer>
        </main>
      </div>
    </DialogHost>
  );
}
